import { Player as IPlayer, Vector2 } from './types';
import { PlayerBullet } from './Bullet';
import { PenetratingBullet } from './SpecialWeapons';
import { clamp } from './utils';

export class Player implements IPlayer {
  position: Vector2;
  velocity: Vector2;
  width: number = 50;
  height: number = 30;
  alive: boolean = true;
  health: number = 3;
  shootTimer: number = 0;
  shootCooldown: number = 0.25;
  speed: number = 300;
  private canvasWidth: number;

  constructor(x: number, y: number, canvasWidth: number = 800) {
    this.position = { x, y };
    this.velocity = { x: 0, y: 0 };
    this.canvasWidth = canvasWidth;
  }

  update(deltaTime: number): void {
    this.shootTimer = Math.max(0, this.shootTimer - deltaTime);
    
    this.position.x += this.velocity.x * deltaTime;
    this.position.x = clamp(this.position.x, 0, this.canvasWidth - this.width);
    
    this.velocity.x *= 0.9;
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#00ff00';
    ctx.fillRect(this.position.x, this.position.y, this.width, this.height);
    
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(this.position.x + 15, this.position.y - 10, 20, 10);
    
    ctx.fillStyle = '#ffff00';
    ctx.fillRect(this.position.x + 10, this.position.y + 5, 10, 10);
    ctx.fillRect(this.position.x + 30, this.position.y + 5, 10, 10);
  }

  moveLeft(): void {
    this.velocity.x = -this.speed;
  }

  moveRight(): void {
    this.velocity.x = this.speed;
  }

  shoot(rapidFire: boolean = false, penetrating: boolean = false): (PlayerBullet | PenetratingBullet)[] {
    const cooldown = rapidFire ? this.shootCooldown * 0.4 : this.shootCooldown;
    
    if (this.shootTimer <= 0) {
      this.shootTimer = cooldown;
      
      const bullets: (PlayerBullet | PenetratingBullet)[] = [];
      
      if (penetrating) {
        bullets.push(new PenetratingBullet(
          this.position.x + this.width / 2 - 2,
          this.position.y - 10
        ));
      } else {
        bullets.push(new PlayerBullet(
          this.position.x + this.width / 2 - 2,
          this.position.y - 10
        ));
      }
      
      if (rapidFire) {
        // 連射時は3way弾
        if (penetrating) {
          bullets.push(new PenetratingBullet(
            this.position.x + this.width / 2 - 8,
            this.position.y - 5
          ));
          bullets.push(new PenetratingBullet(
            this.position.x + this.width / 2 + 4,
            this.position.y - 5
          ));
        } else {
          bullets.push(new PlayerBullet(
            this.position.x + this.width / 2 - 8,
            this.position.y - 5
          ));
          bullets.push(new PlayerBullet(
            this.position.x + this.width / 2 + 4,
            this.position.y - 5
          ));
        }
      }
      
      return bullets;
    }
    return [];
  }

  takeDamage(): void {
    this.health--;
    if (this.health <= 0) {
      this.alive = false;
    }
  }

  reset(x: number, y: number): void {
    this.position.x = x;
    this.position.y = y;
    this.velocity.x = 0;
    this.velocity.y = 0;
    this.health = 3;
    this.alive = true;
  }
}